import React from 'react';

import { EmptyState } from '@/components/atoms/EmptyState';

interface Props {
  readonly title: string;
  readonly message: string;
}

export const EmptyTableView: React.FC<React.PropsWithChildren<Props>> = (
  props: React.PropsWithChildren<Props>,
): React.ReactElement => {
  const { title, message, children } = props;

  return (
    <EmptyState.Container>
      <EmptyState.Title>{title}</EmptyState.Title>
      <EmptyState.Message>{message}</EmptyState.Message>
      {children}
    </EmptyState.Container>
  );
};
